"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Navbar_1 = __importDefault(require("./Navbar"));
const Visualization_1 = __importDefault(require("./Visualization"));
require("../styles/main.css");
const App = () => {
    const [route, setRoute] = (0, react_1.useState)(() => window.location.hash.replace('#/', '') || 'home');
    (0, react_1.useEffect)(() => {
        const onHashChange = () => setRoute(window.location.hash.replace('#/', '') || 'home');
        window.addEventListener('hashchange', onHashChange);
        return () => window.removeEventListener('hashchange', onHashChange);
    }, []);
    const content = (0, react_1.useMemo)(() => {
        switch (route) {
            case 'algebra':
                return react_1.default.createElement(Visualization_1.default, { type: "algebra" });
            case 'geometry':
                return react_1.default.createElement(Visualization_1.default, { type: "geometry" });
            case 'calculus':
                return react_1.default.createElement(Visualization_1.default, { type: "calculus" });
            case 'fourier':
                return react_1.default.createElement(Visualization_1.default, { type: "fourier" });
            case 'fractals':
                return react_1.default.createElement(Visualization_1.default, { type: "fractals" });
            case 'riemann':
                return react_1.default.createElement(Visualization_1.default, { type: "riemann" });
            case 'vectorfields':
                return react_1.default.createElement(Visualization_1.default, { type: "vectorfields" });
            case 'conic-sections':
                return react_1.default.createElement(Visualization_1.default, { type: "conic-sections" });
            case 'complex-mapping':
                return react_1.default.createElement(Visualization_1.default, { type: "complex-mapping" });
            case 'probability':
                return react_1.default.createElement(Visualization_1.default, { type: "probability" });
            default:
                return (react_1.default.createElement("section", { className: "home" },
                    react_1.default.createElement("h1", null, "Maths Explorer (Beta 0.1)"),
                    react_1.default.createElement("p", { style: { marginBottom: 32 } }, "Explore maths through interactive visualisations designed for students. Tinker with parameters, see concepts come alive, and build intuition for various mathematical concepts."),
                    react_1.default.createElement("div", { className: "visualization-grid" },
                        react_1.default.createElement("div", { className: "visualization-card" },
                            react_1.default.createElement("h3", null, "Maclaurin Series"),
                            react_1.default.createElement("p", null, "Compare functions with their Maclaurin series approximations. Watch how adding more terms improves the approximation near x = 0."),
                            react_1.default.createElement("a", { href: "#/calculus", className: "card-link" }, "Explore Calculus \u2192")),
                        react_1.default.createElement("div", { className: "visualization-card" },
                            react_1.default.createElement("h3", null, "Fourier Series"),
                            react_1.default.createElement("p", null, "See how periodic functions are built from sine and cosine waves. Animate the convergence and explore the Gibbs phenomenon."),
                            react_1.default.createElement("a", { href: "#/fourier", className: "card-link" }, "Explore Fourier \u2192")),
                        react_1.default.createElement("div", { className: "visualization-card" },
                            react_1.default.createElement("h3", null, "Mandelbrot Set"),
                            react_1.default.createElement("p", null, "Explore the infinite complexity of fractal geometry. Zoom into self-similar patterns and discover the boundary between convergence and divergence."),
                            react_1.default.createElement("a", { href: "#/fractals", className: "card-link" }, "Explore Fractals \u2192")),
                        react_1.default.createElement("div", { className: "visualization-card" },
                            react_1.default.createElement("h3", null, "Riemann Sums"),
                            react_1.default.createElement("p", null, "Visualize the area under curves using rectangles and trapezoids. Watch the limit process as approximations converge to exact integrals."),
                            react_1.default.createElement("a", { href: "#/riemann", className: "card-link" }, "Explore Integration \u2192")),
                        react_1.default.createElement("div", { className: "visualization-card" },
                            react_1.default.createElement("h3", null, "Vector Fields"),
                            react_1.default.createElement("p", null, "Explore directional fields and particle flow. Watch particles follow force lines in gravitational, electric, and fluid flow fields."),
                            react_1.default.createElement("a", { href: "#/vectorfields", className: "card-link" }, "Explore Vector Fields \u2192")),
                        react_1.default.createElement("div", { className: "visualization-card" },
                            react_1.default.createElement("h3", null, "Conic Sections"),
                            react_1.default.createElement("p", null, "Slice a 3D cone to generate circles, ellipses, parabolas and hyperbolas. Explore how the angle of intersection creates different curves."),
                            react_1.default.createElement("a", { href: "#/conic-sections", className: "card-link" }, "Explore Conic Sections \u2192")),
                        react_1.default.createElement("div", { className: "visualization-card" },
                            react_1.default.createElement("h3", null, "Complex Mappings"),
                            react_1.default.createElement("p", null, "See how complex functions transform the plane with conformal mappings. Visualize functions like z\u00B2, sin(z), and 1/z."),
                            react_1.default.createElement("a", { href: "#/complex-mapping", className: "card-link" }, "Explore Complex Mappings \u2192")),
                        react_1.default.createElement("div", { className: "visualization-card" },
                            react_1.default.createElement("h3", null, "Probability Distributions"),
                            react_1.default.createElement("p", null, "Explore normal distributions with interactive controls. Adjust mean, standard deviation and see the effects."),
                            react_1.default.createElement("a", { href: "#/probability", className: "card-link" }, "Explore Probability \u2192")))));
        }
    }, [route]);
    return (react_1.default.createElement("div", { className: "app" },
        react_1.default.createElement(Navbar_1.default, { active: route }),
        react_1.default.createElement("main", { className: "container" },
            content,
            react_1.default.createElement("footer", { style: {
                    textAlign: 'center',
                    marginTop: '2rem',
                    padding: '1rem',
                    color: '#666',
                    fontSize: '0.9rem'
                } }, "\u00A9 Michael Sibilev, 2025"))));
};
exports.default = App;
